import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoneTypeEnum, PlanTypeEnum } from '../../core';
import { ArchiveService } from '../../services';
import { BaseComponent, BoneTypeLabelPipe, PlanTypeLabelPipe } from '../../shared';


/**
* Filters component to filter archive list.
*/
@Component({
	selector: 'archive-filters',
	templateUrl: './archive-filters.component.html',
	imports: [
		FormsModule,
		PlanTypeLabelPipe,
		BoneTypeLabelPipe,
		ReactiveFormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ArchiveFiltersComponent extends BaseComponent {

	private readonly formBuilder = inject(FormBuilder);
	private readonly archiveSrv = inject(ArchiveService);

	form: FormGroup = this.formBuilder.group({
		bone: new FormControl(),
		planType: new FormControl()
	});

	readonly boneList: BoneTypeEnum[] = Object.values(BoneTypeEnum);
	readonly planTypeList: PlanTypeEnum[] = Object.values(PlanTypeEnum);


	/**
	* Reset all filters.
	*/
	clear(): void {
		this.form.reset();
	}

	/**
	* Update list.
	*/
	search(): void {
		this.archiveSrv.updateFilter(this.form.value.bone, this.form.value.planType);
		this.archiveSrv.search();
	}

}
